import styled, { css } from "styled-components";

import { rgba } from "@similarweb/styles";

interface KeywordGroupScatterPlotDataLabelProps {
    isPreviousPeriod: boolean;
    color: string;
    radius: number;
    outlineWidth?: number;
}

type CircleProps = {
    [K in keyof KeywordGroupScatterPlotDataLabelProps as `$${K}`]: KeywordGroupScatterPlotDataLabelProps[K];
};

const Circle = styled.div<CircleProps>`
    ${({ $isPreviousPeriod, $color, $radius, $outlineWidth }) => {
        const diameter = `${2 * $radius}px`;
        const outline = `${$outlineWidth}px ${$isPreviousPeriod ? "dashed" : "solid"} ${$color}`;
        const outlineOffset = `-${$outlineWidth}px`;
        const offset = `-${$radius}px`;

        return css`
            position: absolute;
            left: ${offset};
            right: ${offset};
            width: ${diameter};
            box-sizing: content-box;
            aspect-ratio: 1;
            border-radius: 50%;
            background-color: ${rgba($color, 0.12)};
            outline: ${outline};
            outline-offset: ${outlineOffset};
        `;
    }}
`;

export const KeywordGroupScatterPlotDataLabel = ({
    isPreviousPeriod,
    color,
    radius,
    outlineWidth = 2,
}: KeywordGroupScatterPlotDataLabelProps) => {
    return (
        <Circle
            $isPreviousPeriod={isPreviousPeriod}
            $color={color}
            $radius={radius}
            $outlineWidth={outlineWidth}
        />
    );
};
